import { Component, ElementRef, OnInit } from '@angular/core';
import { InceptionService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-cyber-care-coverage',
  templateUrl: './cyber-care-coverage.component.html',
  styleUrls: ['./cyber-care-coverage.component.css'],
})
export class CyberCareCoverageComponent implements OnInit {
  constructor(
    private inceptionService: InceptionService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    this.initInception();
  }

  initInception() {
    setTimeout(() => {
      this.inceptionService.tabs(this.elementRef.nativeElement);
    });
  }
}
